import { GetProfileResponseContent } from '@equaliq/api-model';
import { createApiRequest } from "../common";

export const getProfileApi = async (userId?: string): Promise<GetProfileResponseContent> => {
  const request = createApiRequest<GetProfileResponseContent>('post', '/getProfile');
  
  // Only include userId in the request if it's provided
  if (userId) {
    return request({ userId });
  } else {
    // Send empty object when no userId is provided to get current user's profile
    return request({});
  }
};